import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, gridSizeMdLg12, useTabsFormOnly } from "@/shared";
import { FormTabsOnly, TabsFormBoxScene } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { TabDatosPerfil, TabDobleFactor, TabSeguridadPerfil } from "./forms";
import { useAuthStore } from "@/store/auth";


export type PerfilGeneralPageProps = {};

const PerfilGeneralPage: React.FC<
  PerfilGeneralPageProps
> = () => {
  const userData = useAuthStore(s => s.user);
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("setup") === "2fa" ? 3 : 1;
//   useCheckPermissions(PermissionsEnum.api_change_agendamiento);
//   const returnUrlAgendamientosPyLPage =
//     ROUTER_PATHS.operaciones.agendamientoPyLNav;
//   const { id } = useParams();

//   const { data, isLoading, isRefetching } = useGetAgendamiento(id!);
//   useLoaders(isLoading || isRefetching);

//   if (isLoading ) return null;
//   if (!data?.data?.id_agendamiento)
//     return <Navigate to={returnUrlAgendamientosPyLPage} />;
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: initialTab,
  });

  return (
    <>
    <TabsFormBoxScene
        titlePage={`Hola ${userData?.username}!`} // only for typescript
        // titlePageNode={<ClienteFibraFormTitle contract={contract!} showRejectButton={true} />}
        // size={gridSizeMdLg10} // actual form container size
        showBtns={false}
        // // custom btns
        size={gridSizeMdLg12}
        pb={0}
        // // tabs
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="Mis Datos" value={1} {...a11yProps(1)} />
            <Tab label="Seguridad" value={2} {...a11yProps(2)} />
            <Tab label="Doble Factor" value={3} {...a11yProps(3)} />
          </FormTabsOnly>
        }
      >
        <CustomTabPanel index={valueTab} value={1}>
          <TabDatosPerfil/>
        </CustomTabPanel>
        <CustomTabPanel index={valueTab} value={2}>
          <TabSeguridadPerfil/>
        </CustomTabPanel>
        <CustomTabPanel index={valueTab} value={3}>
          <TabDobleFactor/>
        </CustomTabPanel>
      </TabsFormBoxScene>
    </>
  );
};

export default PerfilGeneralPage;
